module.exports = __webpack_public_path__ + "img/vard6.28e0b23f.png";